var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"20px"}},[_c('Ckeditor',{directives:[{name:"highlight",rawName:"v-highlight"}],attrs:{"content":_vm.questionesData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }